import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsScenarioReport } from '@kurtosys/types/query/options/IQueryOptionsScenarioReport.js';

import { commonUtils } from '../../common/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class ScenarioReportQuery extends BaseQuery<IQueryOptionsScenarioReport> {
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsScenarioReport {
		const { code, codeQuery, key, keyQuery, options = {} } = this.queryOptions;
		return {
			code,
			codeQuery,
			key,
			keyQuery,
			...(options.scenarioReport || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key } = this.queryOptions;
		const instance = this.getScenarioReportFromContext(executionOptions);
		if (commonUtils.isObject(instance) && code) {
			if (code === 'extended') {
				if (commonUtils.isObject(instance.extended)) {
					return instance.extended[key] as T;
				}
			} else {
				return instance[code];
			}
		}
		return undefined;
	}
}
